<template lang="">
  <div>
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <div class="gWidth bg-white padding" id="map" v-cloak>
      <section class="mapbox bg-white">
        <div class="head_topp">
          网站地图
        </div>
        <ul class="head_btmm">
          <li class="big_flex">
            <span>高新概况</span>
            <ol>
              <li>
                <router-link to="/gaikuang/18" class="text-gray"
                  >高区概况</router-link
                >
              </li>
              <li>
                <router-link to="/gaikuang/18" class="text-gray"
                  >领导班子</router-link
                >
              </li>
              <li>
                <router-link to="/gaikuang/18" class="text-gray"
                  >组织机构</router-link
                >
              </li>
            </ol>
          </li>
          <li class="big_flex">
            <span>政务服务</span>
            <ol>
              <li>
                <a
                  href="http://www.hbzwfw.gov.cn/hbzw/threesxcx/itemList/gr_index.do?webId=118&zt=07&deptid="
                  target="_blank"
                  >个人办事</a
                >
              </li>
              <li>
                <a
                  href="http://www.hbzwfw.gov.cn/hbzw/threesxcx/itemList/fr_index.do?webId=118&enterprise_zt=01&deptid="
                  target="_blank"
                  >法人办事</a
                >
              </li>
            </ol>
          </li>
          <li class="big_flex">
            <span>政府信息公开</span>
            <!-- 没写 -->
            <ol>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/Zhinan"
                  target="_blank"
                  >政府信息公开指南</a
                >
              </li>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/Gknr"
                  target="_blank"
                  >法定主动公开</a
                >
              </li>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/Zhongdian?id=6"
                  target="_blank"
                  >重点领域</a
                >
              </li>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/Yishenqing"
                  target="_blank"
                  >依申请公开</a
                >
              </li>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/gongkai?id=150"
                  target="_blank"
                  >政府信息公开年报</a
                >
              </li>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/Jiedu"
                  target="_blank"
                  >政策解读</a
                >
              </li>
            </ol>
          </li>
          <li class="big_flex">
            <span>专题专栏</span>
            <ol>
              <li>
                <router-link to="/ztzl?id=25&index=0">环境治理</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=24&index=1">食品安全</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=27&index=2">扶贫专栏</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=28&index=3">征地告知</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=72&index=4">重点领域信息公开</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=122&index=5">收费项目</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=123&index=6">消防专栏</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=134&index=7">规划信息</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=140&index=8">招考招录</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=147&index=9">财政预决算</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=148&index=10">建议提案</router-link>
              </li>
              <li>
                <router-link to="/ztzl?id=152&index=11">惠民惠农</router-link>
              </li>
            </ol>
          </li>
          <!-- <li class="big_flex">
            <span>文件下载</span>
            <ol>
              <li>
                <router-link to="/ztzl">文件下载</router-link>
              </li>
            </ol>
          </li> -->
          <li class="big_flex">
            <span>依申请公开</span>
            <ol>
              <li>
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html#/Yishenqing"
                  target="_blank"
                  >网上依申请公开</a
                >
              </li>

              <li>
                <!-- <a
                  href="http://zwgk.20cm.net/zwgk/index.html#miao"
                  target="_blank"
                  >查询</a
                > -->
                <a
                  href="https://www.bdgxq.gov.cn/zwgk/index.html"
                  target="_blank"
                  >查询</a
                >
              </li>
            </ol>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "Maps",
  components: {
    PositionGuid,
  },
  data() {
    return {
      posGuids: [
        {
          title: "网站地图",
          link: "",
        },
      ],
    };
  },
};
</script>
<style src="../../../vab/styles/map/map_big.css" scoped></style>
<style src="../../../vab/styles/map/map_small.css" scoped></style>
